import {
  usePermissionReason,
  useRbacManageAnyDisabled,
  useRbacNavDisabled,
} from 'hooks/useRbacNavCheck'

export type ServiceChargePermissions = {
  // True when the section must render nothing — a shell would leak that
  // service charges are configured to a user with no view grant.
  sectionHidden: boolean
  editDisabled: boolean
  editDisabledReason: string | undefined
}

/**
 * Gates the Service Charges section independently of the `Locations` route
 * gate, since `ordering_configuration` (OrderingManagement) and `Locations`
 * are separate grants — see permissionMap.ts.
 */
export const useServiceChargePermissions = (): ServiceChargePermissions => {
  const sectionHidden = useRbacNavDisabled('OrderingManagement')
  const editDisabled = useRbacManageAnyDisabled(['OrderingManagement'])
  const editDisabledReason = usePermissionReason(
    'OrderingManagement',
    editDisabled
  )

  return { sectionHidden, editDisabled, editDisabledReason }
}
